<mat-form-field
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 url-wrapper w-full"
>
  <mat-label>
    <span
      class="block text-ellipsis overflow-hidden pointer-events-auto"
      [matTooltip]="fieldDef.label"
      tooltipIfEllipsis
    >
      {{ fieldDef.label }}
    </span>
  </mat-label>
  <div class="w-full flex flex-row" (click)="edit()" (focus)="edit()">
    <input
      #inputControl
      matInput
      [(ngModel)]="value"
      (keyup.enter)="onBlur()"
      [maxLength]="1024"
      (blur)="onBlur()"
      [disabled]="isDisabled"
      [ngClass]="{ underline: value && !fieldDef.meta?.value_hidden, disabled: isDisabled }"
      [class.blurred]="fieldDef.meta?.value_hidden"
    />
    @if (!fieldDef.meta?.value_hidden) {
      @if (value && !editing) {
        <ts-button
          type="icon"
          icon="open_in_new"
          iconTooltip="Navigate to URL"
          class="navigation-button"
          (buttonClick)="visitUrl()"
        ></ts-button>
      }
    }
  </div>
</mat-form-field>
